export enum AppMode {
    Standalone = "standalone",
    Modal = "modal",
    Embedded = "embedded",
}

export const getAppMode = (): AppMode => {
    const isIframe = window.self !== window.top;
    const isModal = window.location.search.includes("isModal=true");

    if (!isIframe) return AppMode.Standalone;
    if (isModal) return AppMode.Modal;
    return AppMode.Embedded;
};

/**
 * Classes put on the document element so stylesheets can target a mode.
 * Embedded must not get `modal`: it is inline content on the host page and its
 * scroll has to chain out to that page rather than being trapped.
 */
export const getDocumentModeClasses = (mode: AppMode): string[] => {
    switch (mode) {
        case AppMode.Modal:
            return ["iframe", "modal"];
        case AppMode.Embedded:
            return ["iframe"];
        case AppMode.Standalone:
            return [];
    }
};
